<template lang="pug">

    div.field(v-on:submit='persist()')
        dropdown-field(
            v-bind:option-label='optionLabel'
            v-bind:option-value='optionValue'
            v-bind:label='label'
            v-bind:options='options'
            v-bind:is-required='required'
            v-model='addressId'
        )
            slot

        modal(ref="modal")
            span(slot="header") Adresse erstellen

            form.ui.form(slot='content')
                address-general-information-form(
                    ref="generalInformation"
                    v-bind:company-models='companyModels'
                    v-bind:country-models='countryModels'
                    v-model='model'
                )

                h3.ui.block.header Adresstyp
                address-types-form(
                    ref="typesForm"
                    v-bind:lock-is-billing-address='forceBillingAddress'
                    v-bind:lock-is-correspondence-address='forceCorrespondenceAddress'
                    v-bind:lock-is-shipping-address='forceShippingAddress'
                    v-model='model'
                )

                h3.ui.block.header Avis
                address-advice-form(v-model='model.advice' ref="adviceForm")

            action-row(
                slot="footer"
                save-type='button'
                v-on:cancel="cancel()"
                v-on:save="persist()"
            )

</template>

<script>
import * as R from "ramda";
import ActionRow from "@/components/form/ActionRow";
import AddressAdviceForm from "@/components/addresses/form/Advice.vue";
import AddressGeneralInformationForm from "./form/GeneralInformation";
import AddressTypesForm from "./form/Types";
import DropdownField from "@/components/form/DropdownField";
import Modal from "@/components/app/Modal";

//noinspection ReservedWordAsName
export default {
  name: "addresses-dropdown-field",

  components: {
    ActionRow,
    AddressAdviceForm,
    AddressGeneralInformationForm,
    AddressTypesForm,
    DropdownField,
    Modal
  },

  computed: {
    companyModels() {
      return [this.companyModel];
    },

    addressId: {
      get() {
        return this.value;
      },
      set(value) {
        // Pruefen ob neue Adresse erstellt werden soll
        if (value === 0) {
          this.showModal();
          return;
        }

        this.$emit("input", value);
      }
    },

    options() {
      return R.prepend(
        { id: 0, name: "- Neue Adresse erstellen -" },
        this.addressModels
      );
    }
  },

  created() {
    this.model.isBillingAddress = this.forceBillingAddress;
    this.model.isCorrespondenceAddress = this.forceCorrespondenceAddress;
    this.model.isShippingAddress = this.forceShippingAddress;
  },

  data() {
    return {
      model: {}
    };
  },

  methods: {
    cancel() {
      this.$emit("input", undefined);
      this.$refs.modal.close();
    },

    persist() {
      // Validierung
      this.validate()
        .then(() => {
          // Speichern
          this.$store
            .dispatch("addresses/create", { model: this.model })
            .then(model => {
              // Message anzeigen
              this.$growl.success("Adresse wurde erstellt");

              // ID "setzen"
              this.$emit("input", model.id);

              // Modal closen
              this.$refs.modal.close();
            });
        })
        .catch(R.always(null));
    },

    showModal() {
      this.model = {
        ...this.model,
        companies: [{ company: this.companyModel.id, notice: '' }]
      };
      this.$refs.modal.show();
    },

    validate() {
      return Promise.all([
        this.$refs.generalInformation.validate(),
        this.$refs.typesForm.validate(),
        this.$refs.adviceForm.validate()
      ]).then(R.all(R.equals(true)));
    }
  },

  props: {
    addressModels: {
      type: Array,
      required: true
    },

    companyModel: {
      type: Object,
      required: true
    },

    countryModels: {
      type: Array,
      required: true
    },

    forceBillingAddress: {
      type: Boolean,
      default: false
    },

    forceCorrespondenceAddress: {
      type: Boolean,
      default: false
    },

    forceShippingAddress: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: "Adresse"
    },

    optionLabel: {
      type: String,
      default: "name"
    },

    optionValue: {
      type: String,
      default: "id"
    },

    required: {
      type: Boolean,
      default: false
    },

    value: {
      type: Number
    }
  }
};
</script>
